import { LogCategory, LogKind } from './log.types';
var registeredLoggers = new Map();
export function addLogger(name, logger) {
    if (registeredLoggers.has(name)) {
        throw new Error("Logger " + name + " already exists");
    }
    registeredLoggers.set(name, logger);
}
export function removeLogger(name) {
    registeredLoggers.delete(name);
}
export function broadcastLogger(options) {
    broadCastTo(options, registeredLoggers);
}
export function addAdditionalLoggers(additionalLoggers) {
    if (additionalLoggers) {
        Object.keys(additionalLoggers).forEach(function (key) {
            addLogger(key, additionalLoggers[key]);
        });
    }
}
function broadCastTo(options, loggers) {
    // eslint-disable-next-line @typescript-eslint/typedef
    loggers.forEach(function (logger, name) {
        try {
            logger(options);
        }
        catch (error) {
            var restLoggers = new Map(loggers);
            restLoggers.delete(name);
            broadCastTo({
                id: '500294',
                type: LogKind.Error,
                logCategory: LogCategory.ClientError,
                message: "Failure in logger: " + name,
                error: error
            }, restLoggers);
        }
    });
}
/**
 * Log messages
 */
export var log = broadcastLogger;
